export const FOOTER_DISCLAIMER_TEXT =
  'If the file includes both closed and active businesses, please upload them separately.'
